import { authHttpRequest, createQueryParams, makeRequest } from './Request';
import {
  getCacheForKey,
  REQUEST_STATUS,
  setCacheForKey,
  attachListener,
  removeListener
} from './CacheManager';
import { getShowcaseId } from './GroupCatalogueAmalgam';

const PROFILE_BASE_KEY = 'PROFILE_BASE_KEY';

const getResellerProfileCacheKey = () => PROFILE_BASE_KEY;

export const attachResellerProfileListener = ({ listener }) => {
  attachListener({ key: getResellerProfileCacheKey(), listener });
};

export const removeResellerProfileListener = ({ listener }) => {
  removeListener({ key: getResellerProfileCacheKey(), listener });
};

export const getResellerProfileDataFromCache = () => getCacheForKey(getResellerProfileCacheKey());

const writeDataToCache = ({ status, data }) => {
  const { status: cachedStatus, data: cachedData } = getResellerProfileDataFromCache() || {};

  setCacheForKey(
    {
      key: getResellerProfileCacheKey(),
      value: {
        status: status || cachedStatus,
        data: data || cachedData
      }
    },
    { notify: true }
  );
};

export const getResellerProfileFromCache = () => {
  const { data } = getResellerProfileDataFromCache() || {};
  return data;
};

export const getGlobalDefaultMarginFromCache = () => {
  const data = getResellerProfileFromCache();
  if (!data) {
    return 0;
  }

  return data.defaultMargin || 0;
};

export const getResellerNameFromCache = () => {
  const data = getResellerProfileFromCache();
  if (!data) {
    return null;
  }

  return data.name || null;
};

export const getResellerProfileRequestStatus = () => {
  const { status } = getResellerProfileDataFromCache() || {};
  return status;
};

const updateResellerProfileApi = (params) =>
  authHttpRequest({
    method: 'PUT',
    url: '/api/reseller/profile',
    params
  });

export const updateResellerProfile = ({ name, defaultMargin }) =>
  makeRequest({
    promiseCacheKey: 'PUT_RESELLER_PROFILE',
    apiFunc: updateResellerProfileApi,
    name,
    defaultMargin,
    groupShowcaseId: getShowcaseId()
  }).then(({ name, defaultMargin }) => {
    writeDataToCache({ data: { name, defaultMargin } });
  });

const fetchResellerProfileApi = () =>
  authHttpRequest({
    method: 'GET',
    url: `/api/reseller/profile${createQueryParams([
      { key: 'groupShowcaseId', value: getShowcaseId() }
    ])}`
  });

export const fetchResellerProfile = () => {
  writeDataToCache({ status: REQUEST_STATUS.LOADING });
  return makeRequest({
    promiseCacheKey: 'FETCH_RESELLER_PROFILE',
    apiFunc: fetchResellerProfileApi
  })
    .then(({ name, defaultMargin }) => {
      writeDataToCache({ status: REQUEST_STATUS.COMPLETE, data: { name, defaultMargin } });
    })
    .catch(() => {
      writeDataToCache({ status: REQUEST_STATUS.ERROR });
    });
};

export const fetchResellerProfileIfNotExists = () => {
  const cachedStatus = getResellerProfileRequestStatus();
  if (cachedStatus && cachedStatus !== REQUEST_STATUS.ERROR) {
    return;
  }

  return fetchResellerProfile();
};
